import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ConditionalWrapperDivs from '../Helpers/ConditionalWrapperDivs';
import ConfigContext from '../../utils/ConfigContext/ConfigContext';

import './FloorPlanImage.scss';

const FloorPlanImage = ( {
  src,
  imgClassName,
  imgAlt,
  disclaimer,
} ) => {
  const { settings } = useContext( ConfigContext );
  const { mode } = settings;
  const isPrint = mode === 'print';

  return src && (
    <ConditionalWrapperDivs
      condition={isPrint}
      classNamesArray={[ 'floorPlanImage' ]}
    >

      {/* This wrapper makes the image full height on print. */}
      <ConditionalWrapperDivs
        condition={isPrint}
        classNamesArray={[ 'floorPlanImage__imageWrapper' ]}
      >

        <img
          className={imgClassName}
          src={src}
          alt={imgAlt}
        />

      </ConditionalWrapperDivs>

      { isPrint && (
        <div className="floorPlanImage__disclaimer">
          { disclaimer }
        </div>
      )}

    </ConditionalWrapperDivs>
  );
};

FloorPlanImage.propTypes = {
  src: PropTypes.string,
  imgClassName: PropTypes.string,
  imgAlt: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
};

FloorPlanImage.defaultProps = {
  src: null,
  imgClassName: '',
};

export default FloorPlanImage;
